import classNames from "classnames";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import React from "react";
import CtaMini from "../components/CtaMini";
import WebsiteMeta from "../components/draftbox-meta/WebsiteMeta";
import Layout from "../components/Layout";
import Pagination from "../components/Pagination";
import PostCard from "../components/PostCard";
import { AllDraftboxPostCardData } from "../models/all-draftbox-post-description.model";
import { PaginationContext } from "../models/pagination.model";

type IndexPageProps = {
  data: {
    allDraftboxPost: AllDraftboxPostCardData;
    draftboxSettings: {
      identity: {
        siteName: string;
        tagLine: string;
        coverUrl: {
          publicURL: string;
          childImageSharp: {
            fluid: any;
          };
        };
      };
      content: {
        cover: {
          title: string;
          description: string;
        };
      };
    };
  };
  location: any;
  pageContext?: PaginationContext;
};

const IndexPage: React.FC<IndexPageProps> = ({
  data,
  location,
  pageContext,
}) => {
  const { allDraftboxPost, draftboxSettings } = data;

  return (
    <Layout>
      <WebsiteMeta />
      <section
        style={{ minHeight: "25vh", overflow: "hidden" }}
        className="text-center bg-cover bg-center max-w-full bg-primary relative"
      >
        <div className="absolute inset-0">
          {draftboxSettings.identity.coverUrl?.childImageSharp && (
            <Img
              className="h-full"
              fadeIn={false}
              loading="eager"
              fluid={draftboxSettings.identity.coverUrl.childImageSharp.fluid}
            />
          )}
          {!draftboxSettings.identity.coverUrl?.childImageSharp &&
            draftboxSettings.identity.coverUrl?.publicURL && (
              <img
                className="w-full h-full object-cover"
                src={draftboxSettings.identity.coverUrl?.publicURL}
                alt=""
              />
            )}
        </div>
        {/* <div className="relative flex items-center py-20 lg:py-32"> */}
        <div className="relative flex items-center py-20 lg:py-32">
          <div
            className={classNames("absolute inset-0", {
              "bg-black opacity-70": draftboxSettings.identity.coverUrl,
              "bg-primaryActive": !draftboxSettings.identity.coverUrl,
            })}
          />
          <div className="z-10 container mx-auto px-6">
            {/* <div className="z-10 max-w-2xl mx-auto px-6"> */}
            <h1 className="dangerous-html mb-4 text-3xl lg:text-5xl leading-tight font-sansBold text-white break-words">
              {draftboxSettings.content.cover.title}
            </h1>
            <div
              dangerouslySetInnerHTML={{
                __html: `<div>${draftboxSettings.content.cover.description}</div>`,
              }}
              className="max-w-4xl mx-auto dangerous-html text-lg lg:text-2xl font-serifLight text-white opacity-85"
            ></div>
          </div>
        </div>
      </section>
      {/* <div className="spacer my-8"></div> */}
      <section className="px-6 container mx-auto">
        <div className="flex justify-center flex-wrap -mx-4">
          {allDraftboxPost.edges.map(({ node }, index) => {
            return <PostCard post={node} index={index} key={index} />;
          })}
        </div>
      </section>

      {/* Pagination */}
      <Pagination pageContext={pageContext} />
      <CtaMini />
    </Layout>
  );
};

export default IndexPage;

export const indexPageQuery = graphql`
  query($limit: Int!, $skip: Int!) {
    allDraftboxPost(
      sort: { fields: [featured, publishedAt], order: [DESC, DESC] }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          ...DraftboxPostCardData
        }
      }
    }

    draftboxSettings {
      identity {
        coverUrl {
          publicURL
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
      content {
        cover {
          title
          description
        }
      }
    }
  }
`;
